var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScrollUp = function SvgScrollUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 44 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.5 0H44v27H13.5a13.5 13.5 0 1 1 0-27",
    opacity: 0.475
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002855",
    d: "M14.96 19.574a1.617 1.617 0 0 0 2.268-.206l6.817-8.18 6.817 8.179a1.612 1.612 0 0 0 2.663-.284 1.61 1.61 0 0 0-.19-1.78L25.282 7.64a1.61 1.61 0 0 0-2.473 0l-8.053 9.664a1.61 1.61 0 0 0 .204 2.27"
  })));
};
export default SvgScrollUp;